import { styled } from "styled-components";

export const DeliveryInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 24px;
`;
